/* @flow */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import TableButton from 'components/TableButton';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import ActionDrawerStore from 'stores/ActionDrawerStore';
import UserStore from 'stores/UserStore';

export type ManageUserLoginViewProps = {
  action: Object,
  id: string,
  title: string,
};

type InjectedProps = {
  actionDrawerStore: ActionDrawerStore,
  userStore: UserStore,
};

@translate()
@inject('actionDrawerStore', 'userStore')
@observer
export default class ManageUserLoginView extends ComponentWithInjectedProps<
  ManageUserLoginViewProps,
  {},
  InjectedProps
> {
  handleActionDrawer = () => {
    const { action, id, userStore, actionDrawerStore } = this.props;

    userStore.selectedUserImpersonate = id;

    action === 'login'
      ? actionDrawerStore.openActionDrawer('loginAsUser')
      : actionDrawerStore.openActionDrawer('viewAsUser');
  };

  render() {
    const {
      action,
      id,
      title,
      userStore: { activeUser, isReadOnly },
    } = this.props;
    const disabled = id === activeUser.id || isReadOnly;
    let iconHref;
    let label;

    switch (action) {
      case 'login':
        iconHref = '#icon-login-as-user';
        label = 'general:actions.login_as_user';
        break;

      case 'view':
      default:
        iconHref = '#icon-view-as-user';
        label = 'general:actions.view_as_user';
    }

    return (
      <TableButton
        label={label}
        iconHref={iconHref}
        onClick={this.handleActionDrawer}
        title={title}
        disabled={disabled}
      />
    );
  }
}
